module.exports = __webpack_public_path__ + "media/3_14.f48c3d93.wav";